// frontend/src/pages/Admin/Dashboard.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getServices, getRealizations, getCategories, getContacts } from '../../services/api';
import { FaFolder, FaCog, FaProjectDiagram, FaEnvelope, FaChartLine } from 'react-icons/fa';

const Dashboard = () => {
  const [stats, setStats] = useState({
    services: 0,
    realizations: 0,
    categories: 0,
    internships: 0,
    applications: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStats();
  }, []);

  const fetchStats = async () => {
    try {
      const [services, realizations, categories, contacts] = await Promise.all([
        getServices(),
        getRealizations(),
        getCategories(),
        getContacts()
      ]);

      // Import internship functions
      const { getInternships, getInternshipApplications } = await import('../../services/api');
      const internships = await getInternships();
      const applications = await getInternshipApplications();

      setStats({
        services: services.data.length,
        realizations: realizations.data.length,
        categories: categories.data.length,
       // contacts: contacts.data.length,
        internships: internships.data.length,
        applications: applications.data.length
      });
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setLoading(false);
    }
  };

  const cards = [
    { title: 'Services', count: stats.services, icon: FaCog, color: 'blue', link: '/admin/services' },
    { title: 'Réalisations', count: stats.realizations, icon: FaProjectDiagram, color: 'green', link: '/admin/realizations' },
    { title: 'Catégories', count: stats.categories, icon: FaFolder, color: 'purple', link: '/admin/categories' },
   // { title: 'Messages', count: stats.contacts, icon: FaEnvelope, color: 'red', link: '/admin/contacts' },
    { title: 'Stages', count: stats.internships, icon: FaChartLine, color: 'indigo', link: '/admin/internships' },
    { title: 'Candidatures', count: stats.applications, icon: FaEnvelope, color: 'orange', link: '/admin/applications' }
  ];

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="py-8 bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4">
        <div className="flex items-center gap-3 mb-8">
          <FaChartLine className="text-blue-600" size={36} />
          <h1 className="text-3xl font-bold text-gray-800">Tableau de Bord</h1>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-8">
          {cards.map((card, index) => (
            <Link
              key={index}
              to={card.link}
              className={`bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 p-6 border-l-4 border-${card.color}-600`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-gray-600 text-sm mb-1">{card.title}</p>
                  <p className="text-3xl font-bold text-gray-800">{card.count}</p>
                </div>
                <div className={`w-16 h-16 bg-${card.color}-100 rounded-full flex items-center justify-center`}>
                  <card.icon className={`text-${card.color}-600`} size={28} />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Actions Rapides</h2>
            <div className="space-y-3">
              <Link
                to="/admin/services"
                className="block p-4 bg-blue-50 rounded-lg hover:bg-blue-100 transition-colors"
              >
                <p className="font-semibold text-blue-600">Gérer les Services</p>
              </Link>
              <Link
                to="/admin/realizations"
                className="block p-4 bg-green-50 rounded-lg hover:bg-green-100 transition-colors"
              >
                <p className="font-semibold text-green-600">Gérer les Réalisations</p>
              </Link>
              <Link
                to="/admin/categories"
                className="block p-4 bg-purple-50 rounded-lg hover:bg-purple-100 transition-colors"
              >
                <p className="font-semibold text-purple-600">Gérer les Catégories</p>
              </Link>
              <Link
                to="/admin/internships"
                className="block p-4 bg-indigo-50 rounded-lg hover:bg-indigo-100 transition-colors"
              >
                <p className="font-semibold text-indigo-600">Gérer les Stages & PFE</p>
              </Link>
              <Link
                to="/admin/applications"
                className="block p-4 bg-orange-50 rounded-lg hover:bg-orange-100 transition-colors"
              >
                <p className="font-semibold text-orange-600">Gérer les Candidatures</p>
              </Link>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold text-gray-800 mb-4">Informations</h2>
            <div className="space-y-4">
              <div className="flex items-center gap-3 text-gray-600">
                <div className="w-2 h-2 bg-blue-600 rounded-full"></div>
                <p>Utilisez les catégories pour organiser vos contenus</p>
              </div>
              <div className="flex items-center gap-3 text-gray-600">
                <div className="w-2 h-2 bg-green-600 rounded-full"></div>
                <p>Les images sont automatiquement optimisées</p>
              </div>
              <div className="flex items-center gap-3 text-gray-600">
                <div className="w-2 h-2 bg-purple-600 rounded-full"></div>
                <p>Publication/dépublication en un clic</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

